// export const BASE_URL = "https://api.alrowadinstitute.edunixsystem.com"
// https://edunix-api.beetronix.com
// https://api.alawal.edunixsystem.com
// export const BASE_URL = 'https://api.gelalshahbaa.edunixsystem.com/'
// export const BASE_URL = 'https://api.alhakem.edunixsystem.com/'

// export const BASE_URL = 'https://api.alrowad-school.edunixsystem.com'
// api.gelalshahbaa.edunixsystem.com/files/logo.png


// export const  BASE_URL = 'https://api.sawa.edunixsystem.com/'
// export const BASE_URL = 'https://api.aljenan.edunixsystem.com/'
// export const BASE_URL = 'https://api.al-qalaji.edunixsystem.com'
// export const BASE_URL = 'https://api.motherland.edunixsystem.com/'

// api.daralfikr.edunixsystem.com/files/logo.png
// export const BASE_URL = 'https://api.mirror.edunixsystem.com/'
// export const BASE_URL = 'https://manager.alawdaschool.com/'
// export const BASE_URL = 'https://al-awdah.beetronix.com/'
// export const BASE_URL = 'https://api.gelalshahbaa.edunixsystem.com/'
// export const BASE_URL = 'https://api.alrowad-school.edunixsystem.com/'
// export const BASE_URL = 'https://api.aljenan.edunixsystem.com'
export const BASE_URL = 'https://api.rowadalmustakbal.edunixsystem.com/'
// export const BASE_URL = 'https://api.alawalschool.edunixsystem.com/'
// export const BASE_URL = 'https://api.alrowad-school.edunixsystem.com/'
// export const BASE_URL = 'https://api.mirror.edunixsystem.com/'
// export const BASE_URL = 'https://api.shamsalassil.edunixsystem.com/'
// export const BASE_URL = 'https://api.albayan-schools.com/'
// export const BASE_URL = 'https://api.sawa.edunixsystem.com/'
// export const BASE_URL = 'https://api.almarah-school.edunixsystem.com'
// export const BASE_URL = 'https://api.motherland.edunixsystem.com/'
// export const BASE_URL = 'http://localhost:44315/'
export const STORAGE_NAME = "auth"
export const STORAGE_ACTIVE_USER = "active-user"